import axios from 'axios'
import Vapi from 'vuex-rest-api'
import { querySerializer } from '@/utils/store'

let logsIdsViewed
try {
  logsIdsViewed = JSON.parse(localStorage.getItem('viewed-notifications-school')) || []
} catch (e) {
  logsIdsViewed = []
}

const api = new Vapi({
  axios,
  state: {
    folders: [],
  },
})
  .get({
    action: 'getFolders',
    property: 'folders',
    path: '/folders',
    queryParams: true,
    requestConfig: querySerializer,
    onSuccess(s, { data: folders }, axios, { params }) {
      s.folders = folders;
    },
  })
  .getStore({ namespaced: true })

export default {
  ...api,
}
